export const CONTACT_REQUEST_RECEIVED = 'contactRequestReceived';
export const CONTACT_REQUEST_ACCEPTED = 'contactRequestAccepted';
export const MEETING_REQUEST_RECEIVED = 'meetingRequestReceived';
export const MEETING_REQUEST_ACCEPTED = 'meetingRequestAccepted';
export const MEETING_STARTING = 'meetingStartingSoon';
